export class ScreenAgentPayloadModel {
    public agentCorrelationKey: string;

    constructor(data?: Partial<ScreenAgentPayloadModel>) {
        Object.assign(this, data);
    }
}
